import { en_CA, fr_CA } from "../app-consts/appConstants";
import { determineLocale } from "../contexts/LocaleContext";
import { Experience, GoogleTowInfo, ServiceDetailsBreakdown } from "../types";
import { resolveTotalTowCost } from "./resolveTotalTowCost";

type CustomServiceDetailsBreakdown = ServiceDetailsBreakdown & {
  towExtraUnitAmt?: number;
  towIncludedQty?: number;
}

type SetDestinationTowInfoParams = {
  distanceInMeters: number;
  benefitsTowCostInfo: CustomServiceDetailsBreakdown;
  experience: Experience;
  benefits: boolean;
};

const milesPerMeter = 0.000621371192;

export const setDestinationTowInfo = ({
  distanceInMeters,
  benefitsTowCostInfo,
  experience,
  benefits,
}: SetDestinationTowInfoParams): GoogleTowInfo => {
  const { ppuEnabled, overMileageEnabled, benefitsEnabled, milesBased, canDetermineFinalCost, dollarBased } =
    experience;

  const locale = determineLocale();
  const isPartnerCanada = locale === en_CA || locale === fr_CA;

  let milesToDestination = Number((distanceInMeters * milesPerMeter).toFixed(1));

  let value = isPartnerCanada ? distanceInMeters / 1000 : milesToDestination;
  let distanceUnits = isPartnerCanada ? "kilometer" : "mile";
  let unitsShorthand = isPartnerCanada ? "km" : "mi";

  if (!benefitsTowCostInfo) {
    return {
      distanceFromCurrentLocation: value,
      distanceUnits,
      unitsShorthand,
    };
  }

  let overMileageDistance = 0;
  let overMileageCost = 0;
  let allowedMiles = benefitsTowCostInfo.towIncludedQty || parseInt(benefitsTowCostInfo.towIncludedDistanceQty);
  let costPerAdditionalMile = benefitsTowCostInfo.towExtraUnitAmt || benefitsTowCostInfo.costPerMile;
  let totalTowCost = resolveTotalTowCost(benefitsTowCostInfo);

  let userCanSelectDestinationOutsideOfLimitsAndPaysInStore = !ppuEnabled && !benefitsEnabled && overMileageEnabled; //PEP
  let userCanNotSelectDestinationOutsideOfLimits = milesBased && !overMileageEnabled; //Miles Based AMC
  let userPaysServiceProviderDirectly = dollarBased && !canDetermineFinalCost && benefits; //Dollar based AMC when over benefits
  let userNeedsToSubmitPayment = ppuEnabled && !userPaysServiceProviderDirectly;

  if (
    (userNeedsToSubmitPayment || userCanSelectDestinationOutsideOfLimitsAndPaysInStore) &&
    milesToDestination > allowedMiles
  ) {
    overMileageDistance = milesToDestination - allowedMiles;
    overMileageCost = overMileageDistance * costPerAdditionalMile;
    totalTowCost += overMileageCost;
  }

  if (userCanNotSelectDestinationOutsideOfLimits && milesToDestination > allowedMiles) {
    overMileageDistance = milesToDestination - allowedMiles;
  }

  return {
    distanceFromCurrentLocation: value,
    distanceUnits,
    unitsShorthand,
    overMileageDistance: overMileageDistance.toFixed(1),
    overMileageCost: overMileageCost.toFixed(2),
    totalTowCost: totalTowCost.toFixed(2),
  };
};
